import React from "react";
import { TFunction } from "i18next";
import { CheckIcon } from "@aureskonnect/react-ui";

import { EtkColumn } from "@components/Common/EtkTable";

import { CustomIconsWrapper } from "./CustomIconsWrapper";

type Params = {
    t: TFunction;
    setShopId: React.Dispatch<React.SetStateAction<string | number>>;
    setFidelity: React.Dispatch<
        React.SetStateAction<FidelityRow | FidelityRow[] | undefined>
    >;
    setIsModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
    isModalOpened: boolean;
    setDataIsUpdated: React.Dispatch<React.SetStateAction<boolean | number>>;
    setSelectedRows: React.Dispatch<React.SetStateAction<FidelityRow[]>>;
    isFidelityArchived: boolean;
    isAddFidelityClicked: boolean;
    setIsAddFidelityClicked: React.Dispatch<React.SetStateAction<boolean>>;
    selectedRows: FidelityRow[];
    setLocalFilterActive: React.Dispatch<React.SetStateAction<boolean>>;
    setIsModalOpenedSupport: React.Dispatch<React.SetStateAction<boolean>>;
    setIsConsult: React.Dispatch<React.SetStateAction<boolean>>;
    setCodeSupport: React.Dispatch<React.SetStateAction<string>>;
};

export function useEtkColumns(params: Params): EtkColumn[] {
    const {
        t,
        setShopId,
        setFidelity,
        setIsModalOpened,
        isModalOpened,
        setDataIsUpdated,
        setSelectedRows,
        isFidelityArchived,
        isAddFidelityClicked,
        setIsAddFidelityClicked,
        selectedRows,
        setLocalFilterActive,
        setIsModalOpenedSupport,
        setIsConsult,
        setCodeSupport,
    } = params;

    return React.useMemo<EtkColumn[]>(
        () => [
            {
                index: 4,
                header: t("Centralized loyalty"),
                cell: (e) => (
                    <span>
                        {e.selectedRow[t("State")] === true && (
                            <CheckIcon
                                className="mt-1 ml-1 cmn_chk_selectButton"
                                height={30}
                                width={30}
                            />
                        )}
                    </span>
                ),
                filterable: true,
            },
            {
                index: 7,
                header: t("Actions"),
                cell: (e) => (
                    <CustomIconsWrapper
                        e={e}
                        setShopId={setShopId}
                        setFidelity={setFidelity}
                        setIsModalOpened={setIsModalOpened}
                        isModalOpened={isModalOpened}
                        setDataIsUpdated={setDataIsUpdated}
                        setSelectedRows={setSelectedRows}
                        isFidelityArchived={isFidelityArchived}
                        isAddFidelityClicked={isAddFidelityClicked}
                        setIsAddFidelityClicked={setIsAddFidelityClicked}
                        selectedRows={selectedRows}
                        setLocalFilterActive={setLocalFilterActive}
                        setIsModalOpenedSupport={setIsModalOpenedSupport}
                        setIsConsult={setIsConsult}
                        setCodeSupport={setCodeSupport}
                    />
                ),
                disableFilter: false,
            },
        ],
        // Why: same rationale as useArrayOfCustomColumns — deps track visible state
        // (tab/modal/selection). Setter props are not memoized upstream; listing
        // them would rebuild the cell renderers on every parent render.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            t,
            isModalOpened,
            isFidelityArchived,
            isAddFidelityClicked,
            selectedRows,
        ]
    );
}
